<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-wallet"></i> Pinjaman Supplier
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                    <button v-if="$can('create pinjaman supplier')" type="button" class="btn btn-primary" @click="addPinjaman">
                        <i class="fas fa-plus-square"></i> Pinjaman
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/pinjaman-suppliers"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="action" slot-scope="props">
                            <button type="button" title="View" @click="view(props.rowData)" class="btn btn-link px-1"><i class="fas fa-eye"></i></button>
                            <button v-if="$can('create pinjaman supplier pembayaran') || isSuperAdmin" type="button" title="Pembayaran" @click="pembayaran(props.rowData)" class="btn btn-link px-1"><i class="fas fa-edit"></i></button>
                            <button v-if="isSuperAdmin" type="button" title="Delete" @click="deleteItem(props.rowData)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="editModal" size="lg" :hide-header="true" :hide-footer="true">
            <edit-form @saved="saved" @cancel="editModal = false"></edit-form>
		</b-modal>

        <b-modal v-model="viewModal" size="lg" :hide-header="true" :hide-footer="true">
            <viewer :isPembayaran="isPembayaran" :value="currentSupplier" @saved="saved" @cancel="viewModal = false" @pembayaranSaved="refresh"></viewer>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import Viewer from './Viewer';
import EditForm from './Form';

export default {
    name: "pembelian-supplier",

    components: {
        SearchBar,
        Viewer,
        EditForm,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentSupplier: null,
            searchText: '',
            searchDate: '',
            searchStatus: '',
            searchGudangId: '',
            searchSupplierId: '',
            viewModal: false,
            editModal: false,
            isPembayaran: false,
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'name',
                    title: 'Supplier',
                    sortField: 'name',
                },
                {
                    name: 'tanggal_pinjaman',
                    title: 'Tanggal Pinjaman',
                    sortField: 'tanggal_pinjaman',
                    callback: 'formatDate',
                },
                {
                    name: 'gudang.gudang.name',
                    title: 'Gudang',
                    sortField: 'gudang_name',
                },
                {
                    name: 'total_pinjaman',
                    title: 'Pinjaman',
                    sortField: 'nominal_pinjaman',
                    callback: 'formatNumber',
                },
                {
                    name: 'total_pembayaran',
                    title: 'Terbayar',
                    sortField: 'nominal_pembayaran',
                    callback: 'formatNumber',
                },
                {
                    name: 'total_sisa_pinjaman',
                    title: 'Sisa',
                    sortField: 'total_sisa_pinjaman',
                    callback: 'formatNumber',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                status: this.searchStatus,
                gudang_id: this.searchGudangId,
                supplier_id: this.searchSupplierId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchStatus = search.searchStatus;
            this.searchGudangId = search.searchGudangId;
            this.searchSupplierId = search.searchSupplierId;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchStatus = '';
            this.searchGudangId = '';
            this.searchSupplierId = '';
            this.refresh();
        },

        addPinjaman() {
            this.currentSupplier = null;
            this.editModal = true;
        },

        pembayaran(rowData) {
            this.isPembayaran = true;
            this.currentSupplier = Object.assign({}, rowData);
            this.viewModal = true;
        },

        view(rowData) {
            this.isPembayaran = false;
            this.currentSupplier = Object.assign({}, rowData);
            this.viewModal = true;
        },

        saved() {
            this.editModal = false;
            this.viewModal = false;
            this.currentSupplier = null;
            this.refresh();
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/pinjaman-suppliers/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/pinjaman-suppliers/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
